/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".section__body[_ngcontent-%COMP%]{display:block;max-height:400px;overflow-y:auto}.remark__container[_ngcontent-%COMP%]{display:flex;align-items:center;border-bottom:1px solid #f5f5f5}.remark__actions[_ngcontent-%COMP%]{display:flex;margin-left:15px}#addRemarkButton[_ngcontent-%COMP%]{background-color:#00b6ac}"];
export { styles as styles };
